import * as types from '../mutation-types'
import { COLLATE_DATA_MANAGER } from '../../data/manager/collatedatamng';

export default {
    namespaced: true,
    state: {
        todayInfo: {}
    },
    mutations: {
        [types.PLUGIN_INIT_TODAY_CALENDAR_INFO](state) {
            state.todayInfo = COLLATE_DATA_MANAGER.getTodayCalendarInfoData();
        }
    },
    actions: {
        initTodayInfo({ commit }) {
            commit(types.PLUGIN_INIT_TODAY_CALENDAR_INFO)
        }
    }
}